<template>
  <div class="register">
    <div class="registerBox">
      <el-form :model="registerForm" :rules="registerFormRules" ref="register">
        <el-form-item label="用户名" prop="name">
          <el-input v-model="registerForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="registerForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="key">
          <el-input v-model="registerForm.key" class="code-input"></el-input>
          <el-button class="GetCodeButton" @click="handleGetCode" :disabled="isGetCodeBtnOff"> {{ getCodeText }} </el-button>
        </el-form-item>
        <el-form-item label="密码" prop="passWord" size="large">
          <el-input v-model="registerForm.passWord" type="password" autoComplete="new-password"></el-input>
        </el-form-item>
        <el-form-item>
          <div id="button-group">
            <el-button @click="$router.push('/')">返回登录</el-button>
            <el-button type="success" @click="handleRegister">注 册</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
/**
 * @description: 注册页面
 */

import {userRegister ,getCode} from "../../api/user";
export default {
  data() {
    return {
      // 注册表单
      registerForm: {
        name: "",
        phone: "",
        key: "",
        passWord: "",
      },
      // 注册表单验证规则
      registerFormRules: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        phone: [
          {
            // 正则校验手机号
            pattern: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入手机号"
          }
        ],
        key: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        passWord: [
          {
            // 正则校验密码强度：长度大于6位，至少包含1个数字、1个大写字母、1个小写字母、1个特殊字符 比如：Abc@123
            pattern: /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/,
            message: "密码长度需要大于6位、且至少包含1个数字、1个大写字母、1个小写字母、1个特殊字符",
          },
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      // 获取验证码按钮内容
      getCodeText: "获取验证码",
      // 获取验证码按钮是否禁用
      isGetCodeBtnOff: false,
      // 重新获取验证码倒计时
      getCodeCountDown: 60
    };
  },
  methods: {
    /* 注册 */
     handleRegister() {
      // 因为后端需要接受json数据，所以将form转换为json格式
			this.$refs['register'].validate(async valid => {
				if(valid){
					const formJson = this.registerForm;
					formJson.phone = parseInt(formJson.phone)
					const { data } = await userRegister(formJson);
					if (data.state === 1) {
					  this.$message.success("注册成功");
					  setTimeout(()=>{
							this.$router.push("/");
						},1000)
					} else {
					  this.$message.error(data.msg);
					}
				}
			})
      
    },
    /* 获取验证码 */
    handleGetCode() {
			var regExp = new RegExp(/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/)
			if(!regExp.test(this.registerForm.phone)) return this.$message.error('请输入正确的手机号')
      if (this.isGetCodeBtnOff) return;
      this.isGetCodeBtnOff = true
			getCode({
				mobile:parseInt(this.registerForm.phone),
				messageType:1
			}).then(res=>{
				this.$message(res.data)
			})
      let timer = setInterval(() => {
        this.getCodeCountDown --
        this.getCodeText = this.getCodeCountDown + "s重新发送"
        if(this.getCodeCountDown < 0) {
          clearInterval(timer)
          this.isGetCodeBtnOff = false
          this.getCodeText = "获取验证码"
          this.getCodeCountDown = 60
        }
      }, 1000);
    }
  },
};
</script>

<style lang="less" scoped>
.register {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/home_bg.svg");
  background-size: cover;
  .registerBox {
    padding: 15px;
    width: 400px;
    height: 500px;
    background-color: transparent;
    // border: 1px solid #eeeeee;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .el-input {
    width: 300px;
  }
  .code-input {
    width: 180px;
  }
  .GetCodeButton {
    display: inline-block;
    margin-left: 20px;
    width: 100px;
  }
  /deep/ .el-form-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  #button-group {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
